import React, { FC } from 'react';
import MuiCollapse, { CollapseProps as MuiCollapseProps } from '@material-ui/core/Collapse';
import { Uds } from '../../types';

export type CollapseProps = Uds<MuiCollapseProps & {}>;

export const Collapse: FC<React.PropsWithChildren<CollapseProps>> = ({ dataTest, ...props }) => (
  <MuiCollapse data-test={dataTest} {...props} />
);
